import React, { useEffect } from 'react'
import LayoutActions from '../redux/actions/LayoutActions'
import { Switch, withRouter, Route, Redirect } from 'react-router-dom'
import UserRoute from '../routers/UserRoute'
import { connect } from 'react-redux'
import { Box } from '@mui/system'
import SuppliersLayout from './SuppliersLayout'
import StockListsLayout from './StockListsLayout'
import { layoutPageComponents as components } from './components/layoutPageComponents'
import { subscribeToRouteSync } from '../utils/routeSyncBridge'

// Resolve which nested layout renders a given setup sub-layout. The suppliers group uses
// SuppliersLayout; anything seeded later falls back to the generic StockListsLayout, so new
// sub-layouts keep working without a code change.
const resolveSubLayout = (subLay) => {
    if (subLay?.key === 'suppliersLayout') return SuppliersLayout
    return StockListsLayout
}

const stripBase = (path) => {
    const base = window.__ADMIN_STOCK_BASENAME__ || '';
    if (!base) return path;
    if (path === base || path === `${base}/`) return '/';
    if (path.startsWith(`${base}/`)) return path.slice(base.length) || '/';
    return path;
};

function SetupLayout({
    setPathCheck,
    permission,
    reformat,
    selectedRestaurant
}) {
    const access = reformat(permission.subPage)
        .sort((a, b) => {
            // Check if either 'order' is null
            if (a.order === null && b.order === null) {
                return 0; // Keep the order unchanged if both are null
            } else if (a.order === null) {
                return 1; // Place 'a' (null) after 'b' (non-null)
            } else if (b.order === null) {
                return -1; // Place 'b' (null) after 'a' (non-null)
            }
            // Sort non-null 'order' values normally
            return a.order - b.order;
        });

    useEffect(() => {
        // Same polling sync as SettingsLayout — the MFE host can change the route without this
        // router seeing it. A nested sub-layout (suppliers) owns pathCheck while one of its routes
        // is active; claiming it here would collapse its tab row back to the plain Setup tabs.
        const checkPathname = () => {
            const strippedPathname = stripBase(window.location.pathname);

            const isSubLayoutActive = permission.subLayouts?.some((subLay) =>
                strippedPathname === subLay.route || strippedPathname.startsWith(subLay.route + '/')
            );

            if (!isSubLayoutActive) setPathCheck(permission.route);
        };

        return subscribeToRouteSync(checkPathname);
    }, [permission.route, permission.subLayouts, setPathCheck])

    return (
        <div>
            <Box>
                <Switch>
                    {permission.subLayouts?.map((subLay, i) => {
                        const SubLayout = resolveSubLayout(subLay)
                        return (
                            <Route
                                key={i}
                                path={subLay.route}
                                render={(props) => <SubLayout {...props} permission={subLay} reformat={reformat} />}
                            />
                        )
                    })}
                    <Route exact path="/stock-app/setup" render={() => <Redirect to={access[0]?.route} />} />
                    {access.map((permission2, i) =>
                        <UserRoute key={i} exact path={permission2.route} component={components[permission2.key]} permission={permission2} />
                    )}

                </Switch>
            </Box>
        </div>
    )
}
const mapStateToProps = (state) => ({
})
const mapDispatchToProps = (dispatch) => ({
    setPathCheck: (data) => dispatch(LayoutActions.setPathCheck(data)),
})
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SetupLayout))
